/* eslint-disable no-param-reassign */
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectInfo } from "types/project";
import { RoomSelectorConfiguration } from "types/roomSelector";
import type { RootState } from "../..";

interface ApplicationState {
  initDone: boolean;
  isResetting: boolean;
  isLoading: boolean;
  projectInfo?: ProjectInfo;
  showNewUserModal?: boolean;
  roomSelectorConfiguration?: RoomSelectorConfiguration;
}

const initialState: ApplicationState = {
  initDone: false,
  isResetting: false,
  isLoading: false,
  projectInfo: undefined,
  showNewUserModal: false,
};

const slice = createSlice({
  name: "applicationState",
  initialState,
  reducers: {
    resetApplication: (state) => {
      state.isResetting = true;
    },
    acknowledgeReset: (state) => {
      state.isResetting = false;
    },
    loadingRequired: (state) => {
      state.isLoading = true;
    },
    loadingStopRequired: (state) => {
      state.isLoading = false;
    },
    applicationInitDone: (state) => {
      state.initDone = true;
    },
    applicationProjectInfoLoaded: (
      state,
      action: PayloadAction<ProjectInfo>,
    ) => {
      state.projectInfo = action.payload;
    },
    showNewUserModal: (state, action: PayloadAction<boolean>) => {
      state.showNewUserModal = action.payload;
    },
    roomSelectorConfigurationLoaded: (
      state,
      action: PayloadAction<RoomSelectorConfiguration>,
    ) => {
      state.roomSelectorConfiguration = action.payload;
    },
  },
});

export const getApplicationState = createSelector(
  (state: RootState) => state.applicationState,
  (state) => state,
);

export const applicationStateActions = slice.actions;

export default slice.reducer;
